import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Spinner, Alert } from 'react-bootstrap';
import { FaEnvelope, FaCheckCircle, FaTimesCircle, FaArrowRight } from 'react-icons/fa';
import axiosClient from '../../services/axiosClient';
import '../assets/scss/pages/_auth.scss';
import './VerifyEmail.css';

const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [verificationStatus, setVerificationStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');
  const [userEmail, setUserEmail] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        console.log('Vérification du token:', token);
        
        const response = await axiosClient.get(`/users/verify/email/${token}`);
        
        console.log('Réponse de vérification:', response.data);
        
        if (response.data.success) {
          setVerificationStatus('success');
          setMessage(response.data.message || 'Votre email a été vérifié avec succès !');
          setUserEmail(response.data.user?.email || '');
          
          // Redirection vers la page login après 3 secondes
          setTimeout(() => {
            navigate('/login');
          }, 3000);
        } else {
          setVerificationStatus('error');
          setMessage(response.data.message || 'La vérification a échoué');
        }
      } catch (error) {
        console.error('Erreur de vérification:', error);
        setVerificationStatus('error');
        
        if (error.response?.data?.message) {
          setMessage(error.response.data.message);
        } else if (error.response?.data?.error) {
          setMessage(error.response.data.error);
        } else {
          setMessage('Une erreur est survenue lors de la vérification de votre email');
        }
      }
    };

    if (token) {
      verifyEmail();
    } else {
      setVerificationStatus('error');
      setMessage('Token de vérification manquant');
    }
  }, [token, navigate]);

  const renderContent = () => {
    switch (verificationStatus) {
      case 'loading':
        return (
          <div className="verify-loading">
            <div className="loading-icon">
              <FaEnvelope className="envelop-icon" />
              <Spinner animation="border" className="spinner" />
            </div>
            <h2>Vérification de votre email...</h2>
            <p>Veuillez patienter pendant que nous vérifions votre adresse email</p>
          </div>
        );

      case 'success':
        return (
          <div className="verify-success">
            <div className="success-icon">
              <FaCheckCircle />
            </div>
            <h2>Email vérifié avec succès !</h2>
            <p>{message}</p>
            {userEmail && (
              <p className="user-email">
                <strong>{userEmail}</strong> est maintenant confirmé
              </p>
            )}
            <div className="redirect-info">
              <p>Vous pouvez maintenant vous connecter à votre compte</p>
              <p>Redirection vers la page de connexion dans...</p>
              <div className="countdown">
                <span>3</span>
                <span>2</span>
                <span>1</span>
              </div>
            </div>
            <button 
              className="btn-redirect" 
              onClick={() => navigate('/login')}
            >
              Se connecter
              <FaArrowRight />
            </button>
          </div>
        );

      case 'error':
        return (
          <div className="verify-error">
            <div className="error-icon">
              <FaTimesCircle />
            </div>
            <h2>Échec de la vérification</h2>
            <p>{message}</p>
            <div className="error-actions">
              <button 
                className="btn-retry" 
                onClick={() => window.location.reload()}
              >
                Réessayer
              </button>
              <button 
                className="btn-home" 
                onClick={() => navigate('/')}
              >
                Retour à l'accueil
              </button>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="verify-email-page">
      <div className="verify-background">
        <div className="background-pattern"></div>
        <div className="background-gradient"></div>
      </div>
      
      <Container fluid className="verify-container">
        <Row className="min-vh-100 align-items-center justify-content-center">
          <Col lg={6} md={8} sm={10} xs={12}>
            <div className="verify-card-wrapper">
              <Card className="verify-card">
                <Card.Body className="verify-card-body">
                  {/* Header */}
                  <div className="verify-header">
                    <div className="logo-container">
                      <img 
                        src="https://res.cloudinary.com/dihtuaq6d/image/upload/v1760187144/xrk9fhrhbahbkvjzy1db.jpg" 
                        alt="SenOffre" 
                        className="verify-logo" 
                      />
                    </div>
                    <h1 className="verify-title">
                      Vérification Email
                      <div className="title-decoration"></div>
                    </h1>
                  </div>

                  {/* Content */}
                  <div className="verify-content">
                    {renderContent()}
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default VerifyEmail;
